import Vue from 'vue'
import router from './router'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import wcView from 'wc-view'
import 'wc-view/style.css'

import store from "./store";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont/iconfont.css'

import "swiper/swiper.min.css"

import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video //引入Video播放器

Vue.use(ElementUI)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(Mint)
Vue.use(wcView)
Vue.config.productionTip = false

// axios 拦截登录
axios.interceptors.request.use((config) => {
  if (localStorage.getItem('accessToken')) {
    config.headers.Authorization = localStorage.getItem('accessToken')
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// axios响应拦截 50000跳转登录
axios.interceptors.response.use((response) => {
  let code = response.data.code
  // 需要登录
  if (code === 50000) {
    localStorage.removeItem('accessToken')
    router.push('/login')
    return Promise.resolve()
  }
  return Promise.resolve(response)
}, (error) => {
  return Promise.reject(error)
})

Vue.prototype.axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js